import {ready} from '../main/utils';
import Vue from '../main/vue';

import Configuration from './components/Configuration.vue';
import ConfigurationFront from './components/ConfigurationFront.vue';
import ConfigurationBack from './components/ConfigurationBack.vue';
import ConfigurationManagement from './components/ConfigurationManagement.vue';
import ConfigurationShowers from './components/ConfigurationShowers.vue';
import ConfigurationToilets from './components/ConfigurationToilets.vue';

ready(() => {
  const el = document.querySelector('#pwt-root');
  if (!el) return;

  Vue.component('Configuration', Configuration);
  Vue.component('ConfigurationFront', ConfigurationFront);
  Vue.component('ConfigurationBack', ConfigurationBack);
  Vue.component('ConfigurationManagement', ConfigurationManagement);
  Vue.component('ConfigurationShowers', ConfigurationShowers);
  Vue.component('ConfigurationToilets', ConfigurationToilets);

  new Vue({
    el,
    comments: true,
    data() {
      return {
        accordionPanel: 'facility',
        configurationTab: 'front'
      };
    },
    computed: {
      accordionScreen() {
        switch (this.accordionPanel) {
          case 'facility':
            return 'img/pwt/PWT-Screen-01.png?v=20200615';
          case 'alerts':
            return 'img/pwt/PWT-Screen-02.png?v=20200615';
          case 'reports':
            return 'img/pwt/PWT-Screen-03.png?v=20200615';
          default:
            return 'img/pwt/PWT-Screen-01.png?v=20200615';
        }
      }
    }
  });
});
